var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconViewList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "32px",
    viewBox: "0 0 35 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_view_list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,21 L26,22 C26,22.5164112 25.6136233,22.9360179 25.1158511,22.993327 L24.9991283,23 L11.0008717,23 C10.4843623,23 10.0640881,22.6139598 10.0066842,22.1166211 L10,22 L10,21 L26,21 Z M26,17 L26,19 L10,19 L10,17 L26,17 Z M26,13 L26,15 L10,15 L10,13 L26,13 Z M24.9991283,9 C25.5156377,9 25.9359119,9.38604019 25.9933158,9.88337887 L26,10 L26,11 L10,11 L10,10 C10,9.48358876 10.3863767,9.06398207 10.8841489,9.00667301 L11.0008717,9 L24.9991283,9 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Devices-window:-view-options",
    transform: "translate(-1062.000000, -420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_view_list",
    transform: "translate(1062.000000, 420.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.99610022 C0,1.34139976 1.35059566,0 2.99921059,0 L35,0 L35,32 L2.99921059,32 C1.34279232,32 0,30.6657405 0,29.0038998 L0,2.99610022 Z",
    id: "bkgd-copy-2",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-11-Copy",
    fill: "#B1B1B1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewList);
export default __webpack_public_path__ + "static/media/icon_view_list.7c9b6fb00d6e76d71835b9af75774c28.svg";
export { ForwardRef as ReactComponent };